import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import Dashboard from '@/views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    component: Layout,
    children: [
      {
        path: '',
        component: Dashboard,
        name: 'Dashboard',
        meta: { title: '首页' }
      }
    ]
  },
  {
    path: '/booking',
    component: () => import('@/views/Booking.vue'),
    name: 'Booking',
    meta: { title: '课程预约' }
  },
  {
    path: '/about',
    component: () => import('@/views/About.vue'),
    name: 'About',
    meta: { title: '关于我们' }
  },
  {
    path: '/profile',
    component: () => import('@/views/Profile.vue'),
    name: 'Profile',
    meta: { title: '我的' }
  },
  {
    path: '/publish-activity',
    component: () => import('@/views/PublishActivity.vue'),
    name: 'PublishActivity',
    meta: { title: '发布活动' }
  },
  {
    path: '/profile/edit',
    component: () => import('@/views/ProfileEdit.vue'),
    name: 'ProfileEdit',
    meta: { title: '个人信息' }
  },
  {
    path: '/invitations',
    component: () => import('@/views/Invitations.vue'),
    name: 'Invitations',
    meta: { title: '教练邀请' }
  },
  {
    path: '/activity-management',
    component: () => import('@/views/ActivityManagement.vue'),
    name: 'ActivityManagement',
    meta: { title: '活动管理' }
  },
  {
    path: '/role-management',
    component: () => import('@/views/RoleManagement.vue'),
    name: 'RoleManagement',
    meta: { title: '角色管理' }
  },
  {
    path: '/role-certification',
    component: () => import('@/views/RoleCertification.vue'),
    name: 'RoleCertification',
    meta: { title: '角色认证' }
  },
  {
    path: '/display-management',
    component: () => import('@/views/DisplayManagement.vue'),
    name: 'DisplayManagement',
    meta: { title: '展示管理' }
  },
  {
    path: '/coach-profile',
    component: () => import('@/views/CoachProfile.vue'),
    name: 'CoachProfile',
    meta: { title: '教练公示' }
  },
  {
    path: '/user-management',
    component: () => import('@/views/UserManagement.vue'),
    name: 'UserManagement',
    meta: { title: '用户管理' }
  },
  {
    path: '/permission-management',
    component: () => import('@/views/PermissionManagement.vue'),
    name: 'PermissionManagement',
    meta: { title: '权限分配' }
  },
  {
    path: '/qualification-management',
    component: () => import('@/views/QualificationManagement.vue'),
    name: 'QualificationManagement',
    meta: { title: '教练资质分类管理' }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 公示页面（无需登录）
const publicPages = ['/dashboard', '/about', '/coach-profile', '/profile']

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  // 公示页面 — 直接放行
  if (publicPages.includes(to.path)) {
    next()
    return
  }

  // 管理页面等 — 需登录，无 token 跳首页
  if (!token) {
    next('/dashboard')
    return
  }

  next()
})

export default router